
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Cholera(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Cholera"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                Cholera is an infectious disease that <b>causes severe
watery diarrhea,</b> which can lead to dehydration and even
death if untreated. It is caused by eating food or drinking
water contaminated with a bacterium called Vibrio
cholerae.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Cholera/1.png")} alt="Gingivitis" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
<p>Key symptoms are diarrhoea and dehydration.</p>
                                <p>  <b>Pain areas:</b> in the abdomen</p>
                                <p><b>Gastrointestinal:</b> nausea, severe diarrhoea, vomiting, or watery diarrhoea</p>
                                <p><b>Whole body:</b> dehydration, lethargy, or water-electrolyte imbalance</p>
                                


                                <a className="links" href="https://en.wikipedia.org/wiki/Cholera">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Cholera;